const config = {
    build_number: '616687',
    build_timestamp: '2026-10-06T18:54:54.726Z',
    build_commit: 'a5493992f63ae4098eae62d780f19de1ecaae793',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
